<template>
  <m-content :fluid="false" :title="title">
    <div v-show="!$route.meta.isPage">
      <m-order2-geo/>
      <m-order2-demo/>
      <m-order2-option/>
      <div style="padding-left: 8px; padding-right: 8px;">
        <p v-show="alertDesc !== ''" v-html="alertDesc" class="m-error-text"></p>
        <div style="display: flex; justify-content: flex-end">
        <b-btn @click="$router.push({name: 'landing'})">Back</b-btn>
        <b-btn variant="primary" @click="count" style="margin-left: 8px">Get Count</b-btn>
        </div>
      </div>
    </div>


    <keep-alive>
      <transition name="my-fade">
        <router-view/>
      </transition>
    </keep-alive>



  </m-content>

</template>

<script>
  import MContent from '@/components/layouts/MContent'
  import MOrder2Demo from '@/components/order2/MOrder2Demo'
  import MOrder2Geo from '@/components/order2/MOrder2Geo'
  import MOrder2Option from '@/components/order2/MOrder2Option'

  export default {
    components: {
      MContent,
      MOrder2Demo,
      MOrder2Geo,
      MOrder2Option
    },
    data () {
      return {
        alertDesc: ''
      }
    },
    computed: {
      datasource () {
        return this.$store.getters['config/datasource']
      },
      isTargetoption () {
        return this.$store.getters['demo/isTargetoption']
      },
      isRouteoption () {
        return this.$store.getters['demo/isRouteoption']
      },
      hasPhoneOption () {
        return this.$store.getters['order/hasPhoneOption']
      },
      hasGeo () {
        return this.$store.getters['order/hasGeo']
      },
      hasDemo () {
        return this.$store.getters['order/hasDemo']
      },
      dataSource () {
        return this.$store.getters['config/datasource']
      },
      title () {
        return this.dataSource.Description
      }
    },
    methods: {
      count () {
        this.alertDesc = ''

        // Check Demo
        if (!this.hasDemo) {
          this.alertDesc += 'Please Defined Target Audience<br>'
        }
        if (this.datasource.isDemoOccupant && !this.isTargetoption) {
          this.alertDesc += 'Please select at least one targeting option<br>'
        }
        if (this.datasource.isDemoOccupant && !this.isRouteoption) {
          this.alertDesc += 'Please select at least one route option<br>'
        }

        // Check Phone Option
        if (!this.hasPhoneOption) {
          this.alertDesc += 'Please select a Phone Option<br>'
        }

        // Check Geo
        if (!(this.hasGeo || this.$store.state.order.GeoType === 20 || this.$store.state.order.GeoType === 23)) {
          this.alertDesc += 'Please Defined Target Georgaphy<br>'
        }

        if (this.alertDesc === '') {
          this.$store.dispatch('order/submitOrder')
        }
      }
    }
  }
</script>

<style scoped>
  .move-enter-active {
    animation: move-in .5s;
  }
  .move-leave-active {
    animation: move-in .5s reverse;
  }

  @keyframes move-in {
    0% {
      left: 100vw
    }
    100% {
      left: 0px;
    }
  }

  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
  }
  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-30px, 0);
    transform: translate(-30px, 0);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }
</style>


// WEBPACK FOOTER //
// src/pages/order/Order2.vue